import { Stack, useTheme } from "@mui/material";
import { AppChip } from ".";
import { APP_COLORS } from "../../../enums";

function ChipList({
  list,
  direction = "row",
  value,
  onChipClick,
  chipProps,
  selectedChipProps,
  noRecord,
  onDelete,
  flatList = false,
  animate = true,
  isChipDisabled,
  getLabel,
}: any) {
  const theme = useTheme();

  return (
    <Stack direction={direction} sx={{ flexWrap: "wrap" }}>
      {list && list.length
        ? list?.map((item, index) => {
          const disabled = isChipDisabled
            ? (typeof isChipDisabled === 'function'
              ? isChipDisabled(item, index)
              : isChipDisabled.includes(item) || isChipDisabled.includes(index))
            : false;

          const isSelected = value === item && !disabled;
          const label = getLabel ? getLabel(item) : item;

          return (
            <AppChip
              key={`chip-list-${chipProps?.id}-${index}`}
              label={label}
              onClick={() => !disabled && onChipClick && onChipClick(item, index)}
              {...chipProps}
              {...(onDelete && {
                onDelete: (e) => onDelete && onDelete({ ...e, item, index }),
              })}
              sx={{
                mr: 1,
                mb: 1,
                cursor: disabled ? "not-allowed" : (onChipClick && !disabled ? "pointer" : "default"),
                ...chipProps?.sx,
                ...(disabled && {
                  backgroundColor: APP_COLORS.errorLight,
                  color: APP_COLORS.error,
                  border: `1px solid ${APP_COLORS.error} !important`,
                  pointerEvents: "none",
                }),
                ...(isSelected && {
                  ...selectedChipProps?.sx,
                }),
              }}
            />
          );
        })
        : noRecord}
    </Stack>
  );
}

export { ChipList };
